function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
}


export default function computeXBasedOnAlignment(alignment = '', x, textWidth, width) {
    if (alignment === 'right')
        return x + (width - textWidth)

    if (alignment === 'center') {
        console.log(`centering text, ${width}, ${textWidth}`);
        let adjustmentToLeft = clamp((textWidth / 2), 0, width/2)
        console.log('adjustment to right', adjustmentToLeft)
        
        return x + (width / 2) - adjustmentToLeft
    }

    return x

}